module.exports = __webpack_public_path__ + "01f9eda49fd6a927c0266e1b3e5980d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/GameDay/res/FastModel_Logomark_RGB.png
// module id = 1126
// module chunks = 0